// extracted by mini-css-extract-plugin
module.exports = {"pulse":"IndicatorBadge_pulse__uBvt6","scale":"IndicatorBadge_scale__KawVp"};